import React, { useContext, useState } from 'react';
import {
    List,
    ListItem,
    ListItemText,
    Collapse,
    ListItemButton
} from '@mui/material';
import { MdDashboard, MdExpandLess, MdExpandMore, MdHome } from "react-icons/md";

import { Link, useNavigate } from 'react-router-dom';
import PrivateRoutList from '../../Router/PrivateRoutList';

import { ContextMenues } from '../../ProtectPages/AdminPanel/MainPanel';




export default function DropdownMenu() {
    const navigate = useNavigate();

    const [selectedMenuName, SetSelectedmenuName] = useState('');
    const { menues, setMenues } = useContext(ContextMenues);
    const [openDropdown, setOpenDropdown] = useState(null);


    const GetPath = (MenuName) => {


        var prout = PrivateRoutList.find(e => e.name === MenuName)
        var path = '';

        if (prout) {
            path = prout.path;

        }
        return path;

    }
    const handleClick = (index) => {
        setOpenDropdown(openDropdown === index ? null : index);
    };


    const handleSelectMenu = (MenuName) => {

        SetSelectedmenuName(MenuName);
        var pathname = GetPath(MenuName);
        if (pathname !== '') navigate(pathname);

    }
    return (
        <List component="nav" sx={{
            // hover states
            '& .MuiListItemButton-root:hover': {
                bgcolor: '#cfcecf',
            },
        }}>
            <ListItemButton onClick={() => { SetSelectedmenuName(''); navigate('Home'); }} sx={{ fontFamily: 'Vazir-Bold !important', fontSize: '17px' }}>
                <MdDashboard /> <Link to={'Home'} style={{ textDecoration: 'none', color: "#000", marginRight: '5px' }}>{'صفحه اصلی'}</Link>
            </ListItemButton>
            {
                menues.map((value, index) => {

                    return (<div key={index}>
                        <ListItemButton onClick={() => handleClick(index + 1)} sx={{ fontFamily: 'Vazir-Bold !important', fontSize: '17px', color: '#000' }}>
                            <ListItemText disableTypography primary={value.title} />
                            {openDropdown === index + 1 ? <MdExpandLess size={24} /> : <MdExpandMore size={24} />}
                        </ListItemButton>
                        <Collapse in={openDropdown === index + 1} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding >
                                {
                                    value.children.map((value1, index1) => {
                                        return (


                                            <div key={index1} style={{ padding: 5, borderBottom: '1px solid gray' }}>
                                                <ListItemButton onClick={() => { handleSelectMenu(value1.menuName) }} sx={{ fontFamily: 'Vazir-Medium !important', background: selectedMenuName === value1.menuName ? '#cfcecf' : '' }}>

                                                    <Link to={GetPath(value1.menuName)} style={{ textDecoration: 'none', color: "#000" }}>{value1.title} </Link>
                                                    {/* <ListItemText primary={value1.title}  /> */}
                                                </ListItemButton>
                                            </div>
                                        )

                                    })
                                }


                            </List>
                        </Collapse>
                    </div>)
                })
            }




        </List >
    );
}